export default "__VITE_ASSET__BiudWTjO__"